var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.0001 20.5C13.0001 21.0523 12.5524 21.5 12.0001 21.5C11.4478 21.5 11.0001 21.0523 11.0001 20.5L11 5.35136C10.2871 6.23292 9.46331 7.61473 8.22689 9.67544L7.16701 11.4419C7.04998 11.637 6.93679 11.8257 6.8274 12.0084L6.82251 12.0166C6.64175 12.3161 6.31985 12.4985 5.97005 12.4998L5.9616 12.4998C5.96166 12.4998 5.96166 12.4998 5.96131 12.4998L5.95873 12.4998C5.38364 12.4955 5.00397 12.0172 5.00003 11.5C4.99679 11.0741 5.24095 10.7647 5.45202 10.4129L6.5119 8.64644L6.55884 8.5682C8.97838 4.53551 10.1996 2.5 11.9999 2.5C13.8001 2.5 15.0213 4.53551 17.4409 8.56821L17.4878 8.64645L18.5477 10.4129C18.7586 10.7645 19.0033 11.0744 19 11.5C18.9961 12.0172 18.6161 12.4955 18.041 12.4998C18.0375 12.4998 18.0381 12.4998 18.0382 12.4998L18.0296 12.4998C17.6799 12.4985 17.358 12.3161 17.1772 12.0166L17.1723 12.0084C17.0629 11.8257 16.9497 11.637 16.8327 11.4419L15.7728 9.67544C14.5366 7.61511 13.7129 6.23343 13 5.35185L13.0001 20.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.34bdde31f08c89f9c430e337a93e7eb5.svg";
export { ForwardRef as ReactComponent };